module.exports = "<p>\n  edit-issuer works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/edit-issuer/edit-issuer.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-issuers/edit-issuer/edit-issuer.component.html
// module chunks = main